export const REDUCER_PAGE_GET_DATA = 'REDUCER_PAGE_GET_DATA'
export const REDUCER_PAGE_CLEAR = 'REDUCER_PAGE_CLEAR'

export const REDUCER_PAGE_EDIT_MODE_CHANGE_TITLE = 'REDUCER_PAGE_EDIT_MODE_CHANGE_TITLE'

export const REDUCER_ALARMS_GET_DATA = 'REDUCER_ALARMS_GET_DATA'
export const REDUCER_ALARMS_CLEAR = 'REDUCER_ALARMS_CLEAR'
export const REDUCER_DOWNTIME_GET_DATA = 'REDUCER_DOWNTIME_GET_DATA'
export const REDUCER_DOWNTIME_CLEAR = 'REDUCER_DOWNTIME_CLEAR'
